module.exports = __webpack_public_path__ + "static/media/SP_S_Timeless_Sforza_White.9dbaebf8.png";